import { useEffect, useRef } from 'react';

const SELECTOR_CALENDARIO = '.react-calendar';

/**
 * Cierra un desplegable de calendario al pulsar fuera de él. A diferencia de `useClickOutside`,
 * solo escucha mientras el desplegable está abierto (`activo`), así que el click que lo abre no lo
 * cierra, e ignora los clicks dentro de cualquier `.react-calendar`.
 *
 * @param {object} ref - ref del contenedor del calendario.
 * @param {Function} alPulsarFuera - se llama con el click que queda fuera.
 * @param {boolean} activo - si el calendario está abierto.
 */
export const useClickFueraDelCalendario = (ref, alPulsarFuera, activo) => {
    const alPulsarFueraRef = useRef(alPulsarFuera);

    useEffect(() => {
        alPulsarFueraRef.current = alPulsarFuera;
    });

    useEffect(() => {
        if (!activo) return undefined;

        const comprobarClick = (evento) => {
            const esClickEnCalendario = evento.target.closest(SELECTOR_CALENDARIO);
            const esClickFuera = ref.current && !ref.current.contains(evento.target) && !esClickEnCalendario;
            if (esClickFuera) alPulsarFueraRef.current();
        };

        document.addEventListener('click', comprobarClick);
        return () => document.removeEventListener('click', comprobarClick);
    }, [activo, ref]);
};
